/**
 * @author Sai Prasad
 * @class UserStatusReports
 */

import React from 'react';
import Table from '../Table';
import InfiniteScroll from "react-infinite-scroll-component";
import { variables } from '../../Tenants';

const UserStatusReports = ({
    reports
}) => {
    return (
            reports && reports.length > 0 && (
                    <div
                        id="scrollableDiv"
                        style={{
                            height: 500,
                            overflow: "auto",
                            display: "flex",
                            flexDirection: "column"
                        }}
                    >
                        <InfiniteScroll
                            dataLength={reports.length}
                            style={{ display: "flex", flexDirection: "column" }}
                            inverse={false}
                            scrollableTarget="scrollableDiv"
                        >
                            <Table
                                columns={[
                                    {
                                        sortable: true,
                                        label: 'Property',
                                        accessor: 'propertyName'
                                    },
                                    {
                                        label: variables.Suite,
                                        accessor: 'suiteName'
                                    },
                                    {
                                        label: 'Name',
                                        accessor: 'name',
                                        cell: data => <div title={data.name}>{data.name}
                                        </div>
                                    },
                                    {
                                        label: 'Email',
                                        accessor: 'email',
                                        cell: data => <div title={data.email}>{data.email}
                                        </div>
                                    },
                                    {
                                        label: 'Phone',
                                        accessor: 'phone'
                                    },
                                    {
                                        label: 'Status',
                                        accessor: 'status'
                                    },
                                    {
                                        label: 'Designation',
                                        accessor: 'designation'
                                    }
                                ]}
                                data={reports}
                            />
                        </InfiniteScroll>
                    </div>
            )
    );
}

export default UserStatusReports;